import './common.css';

function formatTime(time) {
    const minutes = Math.floor(time / 60000);
    const seconds = Math.floor(time / 1000) % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function getElapsedTime(limit) {
    const date = new Date();
    const currentTime = date.getTime();
    const loggedTime = localStorage.getItem("loggedTime");
    if (loggedTime) {
        const delta = currentTime - loggedTime;
        if (delta > limit) {
            localStorage.setItem("loggedTime", currentTime);
            return formatTime(0);
        }
        return formatTime(limit - delta);
    } else {
        localStorage.setItem("loggedTime", currentTime);
        return formatTime(limit);
    }
}

export function RedButton({ children, onClick, disabled, style }) {
    return (
        <button
            className="redButton"
            onClick={onClick}
            disabled={disabled}
            style={style}
        >
            {children}
        </button>
    );
}

export function RedInput({ inputRef, label, placeholder, type = "text", onChange }) {
    return (
        <div className="redInputWrapper">
            {label && <label className="redInputLabel">{label}</label>}
            <input
                ref={inputRef}
                type={type}
                className="redInput"
                placeholder={placeholder}
                onChange={onChange}
            />
        </div>
    );
}

export function GoogleButton({ onClick }) {
    return (
        <button className="googleButton" onClick={onClick}>
            <img src={`${process.env.PUBLIC_URL}/google.svg`} alt="Google" />
            Continue with Google
        </button>
    );
}

export function OutlineButton({ children, onClick }) {
    return (
        <button className="outlineButton" onClick={onClick}>
            {children}
        </button>
    );
}

export function DiscordButton({ onClick }) {
    return (
        <button className="discordButton" onClick={onClick}>
            <img src={`${process.env.PUBLIC_URL}/discord.svg`} alt="Discord" />
            Discord
        </button>
    );
}

export function BackArrow({ onClick }) {
    return (
        <div className="backArrow" onClick={onClick}>
            <img src={`${process.env.PUBLIC_URL}/arrow-left.svg`} alt="Back" />
        </div>
    );
}

export function LoginButton({ children, onClick }) {
    return (
        <button className="loginButton" onClick={onClick}>
            {children}
        </button>
    );
}

export function GrayButton({ children, onClick, disabled, style }) {
    return (
        <button
            className="grayButton"
            onClick={onClick}
            disabled={disabled}
            style={style}
        >
            {children}
        </button>
    );
}
